import { Link } from 'react-router-dom';
import { Lock, Sparkles } from 'lucide-react';
import {
  LYRRAONE_FEATURE_LABELS,
  LYRRAONE_PLAN_LABELS,
  LYRRAONE_FEATURE_MIN_TIER,
  LYRRAONE_SUBSCRIPTION_PATH,
  type LyrraOnePlanFeature,
} from '@/lib/lyrraone-plan';
import { useLyrraOnePlan } from '@/hooks/useLyrraOnePlan';

type LyrraOnePlanUpgradeCardProps = {
  feature: LyrraOnePlanFeature;
  title?: string;
  description?: string;
  compact?: boolean;
};

export function LyrraOnePlanUpgradeCard({
  feature,
  title,
  description,
  compact = false,
}: LyrraOnePlanUpgradeCardProps) {
  const { plan } = useLyrraOnePlan();
  const minTier = LYRRAONE_FEATURE_MIN_TIER[feature];
  const featureLabel = LYRRAONE_FEATURE_LABELS[feature];
  const minPlanLabel = LYRRAONE_PLAN_LABELS[minTier];
  const currentPlanLabel = LYRRAONE_PLAN_LABELS[plan];

  return (
    <div
      className={
        compact
          ? 'lo-plan-upgrade lo-plan-upgrade--compact rounded-xl border border-dashed p-4'
          : 'lo-plan-upgrade mx-auto max-w-lg rounded-2xl border p-8 text-center shadow-sm'
      }
      style={{
        borderColor: 'var(--lo-icon-bg, #e2e8f0)',
        background: 'var(--lo-surface, #fff)',
      }}
    >
      <span
        className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full"
        style={{ background: 'color-mix(in srgb, var(--lo-blue) 12%, transparent)' }}
      >
        {minTier === 'expert' ? (
          <Sparkles className="h-6 w-6" style={{ color: 'var(--lo-blue)' }} aria-hidden />
        ) : (
          <Lock className="h-6 w-6" style={{ color: 'var(--lo-blue)' }} aria-hidden />
        )}
      </span>
      <h2 className="text-lg font-bold" style={{ color: 'var(--lo-navy)' }}>
        {title ?? `${featureLabel} — plan ${minPlanLabel}`}
      </h2>
      <p className="mt-2 text-sm leading-relaxed" style={{ color: 'var(--lo-text-tertiary)' }}>
        {description
          ?? `Votre plan ${currentPlanLabel} n'inclut pas ${featureLabel.toLowerCase()}. Passez au plan ${minPlanLabel} pour débloquer cette fonctionnalité.`}
      </p>
      <Link
        to={LYRRAONE_SUBSCRIPTION_PATH}
        className="lo-btn-primary mt-6 inline-flex items-center justify-center px-5 py-2.5 text-sm font-semibold"
      >
        Voir les offres
      </Link>
    </div>
  );
}
